export default __webpack_public_path__ + "static/media/vox-img-legacy-018.c6bb77a0.jpg";